const MoneyConfig = {
  decimal: ',',
  thousands: ' ',
  prefix: '',
  precision: 0,
  masked: false
}

export default MoneyConfig
